// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-redes{border-radius:3px;overflow:hidden}.button-redes .overlay-black{background:rgba(0,0,0,.2)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
